// removed by extract-text-webpack-plugin
module.exports = {"aliCard":"About__aliCard__27rm5","mainDiv":"About__mainDiv__2vfCn","aliImg":"About__aliImg__jABl4","container":"About__container__2u6FE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/About/About.css
// module id = 435
// module chunks = 17